<template></template>
<script>
import { getUserAndTokenByCode } from "@/api/login";
export default {
  name: "loginIdt",
 
  methods: {
    // 内部idt登录完后回到这个页面获取用户信息
    getUserInfo(hostName, NODE_ENV,VUE_APP_ML_HOST) {
      getUserAndTokenByCode({
        code: this.$route.query.code,
        redirectUri:  hostName != VUE_APP_ML_HOST ? process.env.VUE_APP_SANGFOR_EU_REDIRECT_URI : process.env.VUE_APP_SANGFOR_REDIRECT_URI,
         type: hostName != VUE_APP_ML_HOST ? "eu" : "mo",
      }).then((res) => {
        console.log(res, "axios返回的数据==res");
        if (res.status != 200) {
          this.$message.warning("请求异常1");
          return;
        }
        localStorage.setItem("token_by_code", res.data.idtToken);
        localStorage.setItem("library_token", res.data.token);
        localStorage.setItem("loginFailTime", 0);
        localStorage.setItem("readPrivacyPolicy", 0);
        localStorage.setItem(
          "library_userInfo",
          JSON.stringify(res.data.user)
        );
        this.$store.commit("SET_USERINFO", res.data.user);
        if (localStorage.getItem("boforeIdtUrl")) {
          const boforeIdtUrl =
            localStorage.getItem("boforeIdtUrl") + "&idt=" + res.data.code;
          location.replace(boforeIdtUrl);
        } else {
          this.$router.push({path:`/home`})
        }
      }).catch(err=>{
        this.$router.replace({path:'/home'})
      })
    },
  },
  created() {
    if (this.$route.query.code) {
      localStorage.setItem('library_login_type','sangfor')
      const { NODE_ENV,VUE_APP_ML_HOST } = process.env;
      let hostName = window.location.hostname;
      this.getUserInfo(hostName, NODE_ENV,VUE_APP_ML_HOST) 
    }else{
      this.$router.replace({path:'/home'})
    }
  },
};
</script>
